<template>
  <div id="js-enneagram-view">
    <enneagram-display
      :data="assessment"
      :userId="parseInt(userId)"
      :isMember="false"
    ></enneagram-display>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import eventMixin from "@/mixins/eventMixin"
import User from "@/lib/user"
import { mapGetters } from "vuex"
import EnneagramDisplay from "@/components/assessments/EnneagramDisplay"
import { AssessmentsAPI } from "@/lib/api"

export default {
  mixins: [titleMixin, eventMixin],
  components: { EnneagramDisplay },
  data: function() {
    return {
      title: "Personality Style",
      userId: this.$route.params.id,
      userType: User.getUserType(),
      assessment: {}
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id

      this.$store
        .dispatch("assessments/assessmentsByUserId", {
          userId: this.userId
        })
        .then(() => {
          this.assessment = this.getAssessmentByType("Enneagram") || {}
        })
    }
    next()
  },
  mounted: function() {
    this.$cable.subscribe({
      channel: "EnneagramProcessChannel",
      room: "public"
    })
  },
  created() {
    this.assessment = this.getAssessmentByType("Enneagram")

    // listener for add enneagram
    this.addListener(
      "enneagram_result:add2",
      ({
        userId,
        primaryType,
        secondaryType,
        tertiaryType,
        selectedType,
        visible
      }) => {
        AssessmentsAPI.addEnneagram(
          userId,
          primaryType,
          secondaryType,
          tertiaryType,
          selectedType,
          visible
        ).then(() => {
          this.$store
            .dispatch("assessments/assessmentsByUserId", {
              userId: userId
            })
            .then(() => {
              this.assessment = this.getAssessmentByType("Enneagram") || {}
            })
        })
      }
    )

    // this.addListener("enneagram_document:upload2", ({ userId, file }) => {
    //   AssessmentsAPI.uploadEnneagramDoc(this.userId, file).then(() => {
    //     this.$store
    //       .dispatch("assessments/assessmentsByUserId", {
    //         userId: userId
    //       })
    //       .then(() => {
    //         this.assessment = this.getAssessmentByType("Enneagram") || {}
    //       })
    //   })
    // })

    this.addListener("memeber_assessments:refresh", ({ userId }) => {
      this.$store
        .dispatch("assessments/assessmentsByUserId", {
          userId: userId
        })
        .then(() => {
          this.assessment = this.getAssessmentByType("Enneagram") || {}
        })
    })
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  },
  channels: {
    EnneagramProcessChannel: {
      connected() {
        console.log("Connected to Enneagram Notification Channel")
      },
      received(data) {
        if (data.user_id == this.userId) {
          this.$store
            .dispatch("assessments/assessmentsByUserId", {
              userId: this.userId
            })
            .then(() => {
              this.assessment = this.getAssessmentByType("Enneagram") || {}
            })
        }
      }
    }
  }
}
</script>
